













































































































import { Component, Watch } from 'vue-property-decorator';
import { ReportsModule } from '@/store/Reporting/ReportsModule';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'AllAccountsReportDialog' })
export default class extends SaascadaVueDialog {

    reportDateAsString: string = "";
    yesterdaysDateAsString: string = new Date().toISOString();
    accountType: string = "";
    currentPage: number = 1;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.currentPage = 1;
            // Calculate the maximum date of the report which should be yesterday at the latest
            const date = new Date();
            date.setDate(date.getDate() - 1);
            // Set yesterdays date for validation and initialise the report date as yesterday
            this.yesterdaysDateAsString = date.toISOString().split('T')[0];
            this.reportDateAsString = this.yesterdaysDateAsString;
        }
    }

    get accountTypeOptions() {
        return ListUtils.accountTypeOptionsShortList();
    }

    get loadingReport() {
        return ReportsModule.loadingReport;
    }

    get loadingReportFailed() {
        return ReportsModule.loadingReportFailed;
    }

    cancel() {
        this.dialog = false;
    }

    downloadReport () {
        let downloadLink = document.getElementById(`all-${this.accountType.toLowerCase()}-accounts-transactions-report-${this.reportDateAsString}.csv`);
        downloadLink.click();
    }

    async run() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            // Move on to the next page
            this.currentPage = 2;
            await ReportsModule.getAllAccountTransactionsProjection({ date: this.reportDateAsString, accountType: this.accountType });
        }
    }

}
